import { Variant } from 'shared/types/product';
import { ExtendedProductDetailProduct } from 'shared/types/product/Product';
import { UIProduct } from 'components/commercetools-ui/organisms/product/product-details/types';

export const toUIProduct = (product: ExtendedProductDetailProduct, variant: Variant) => {
  const mappedProduct: UIProduct = {
    productId: product.productId,
    productKey: product.productKey,
    productRef: product.productRef,
    // Variant URLs (option links, Product/ProductGroup JSON-LD) are built from the slug.
    slug: product.slug,
    type: product.type,
    name: product?.name ?? '',
    variants: product?.variants,
    useWirebrush: product.useWirebrush,
    isWoodProduct: product.isWoodProduct,
    finishes: product.finishes,
    finishSets: product.finishSets,
    variantFinishSetId: product.variantFinishSetId,
    reviewRatingStatistics: product.reviewRatingStatistics,
    sheens: product.sheens,
    sheenSets: product.sheenSets,
    variantSheenSetId: product.variantSheenSetId,
    price: variant?.price ?? {},
    variantsMap: product.variantsMap,
    categories: product?.categories,
    variantDefiningAttributes: product?.variantDefiningAttributes,
    variantDefiningAttributeGroups: product.variantDefiningAttributeGroups,
    images:
      variant?.images?.map((img: string, id: number) => ({
        id: `${variant?.sku}-${id}`,
        src: img,
        alt: variant?.sku,
      })) ?? [],
    description: product.description || '',
  };

  return mappedProduct;
};
